export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-6">关于番茄影视</h2>
          <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
            <p>
              番茄影视大全是一家专注于高清影视资源整合与分发的在线平台，致力于为广大影视爱好者提供便捷、流畅、免费的观影服务。平台自上线以来，始终坚持「内容为王、体验至上」的核心理念，持续扩展片库覆盖范围，优化播放技术体验。
            </p>
            <p>
              我们的片库覆盖电影、电视剧、综艺、动漫、纪录片等全类型内容，资源总量超过10万部，涵盖华语、日韩、欧美等多个地区。每日实时追踪最新上线的热播剧集和高分影片，确保用户第一时间获取优质观影资源。
            </p>
            <p>
              番茄影视采用先进的智能分发技术，支持多线路切换和自适应码率播放，无论您是使用电脑、平板还是手机，都能享受流畅无阻的高清观影体验。平台无需注册、无需会员、无需任何费用，真正做到零门槛畅享影视世界。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}